import {Doughnut} from "vue-chartjs";
import updateChartMixin from "@/components/widgets/updateChartMixin";
import palette from "google-palette";

export default {
    extends: Doughnut,
    mixins: [updateChartMixin],
    props: {
        options: {
            type: Object,
            default: () => null
        },
        value: {
            type: Array,
            required: true
        }
    },
    computed: {
        allBookings() {
            return this.value.reduce((sum, s) => sum + s.value, 0);
        },
        data() {
            return {
                datasets: [{
                    label: "Bookings Per Service",
                    data: this.value.map(x => x.value),
                    backgroundColor: palette('tol', this.value.length).map(function (hex) {
                        return '#' + hex;
                    })
                }],
                labels: this.value.map(x => `${x.name} (${Number(x.value / this.allBookings * 100).toFixed(2)}%)`)
            }
        }
    },
    mounted() {
        this.renderChart(this.data, this.options);
    }
};